import { Plus, X, UserX } from "lucide-react";
import AdminPageShell from "@/admin/AdminPageShell";
import { useAdminUsersList } from "@/admin/useAdminUsersList";

const AdminUsers = () => {
  const { users, assignableRoles, creating, loading, openNew, close, save, deactivate, updateCreatingField } = useAdminUsersList();

  return (
    <AdminPageShell
      title="Users"
      description="Team members with access to the Command Centre."
      actions={<button onClick={openNew} className="btn-solid-pearl btn-pill-sm" data-testid="admin-users-new-btn"><Plus size={14} /> New User</button>}
      testId="admin-users-page"
    >
      {creating && (
        <form onSubmit={save} className="neu-panel p-6 mb-8 space-y-4" data-testid="admin-user-form">
          <div className="flex items-center justify-between"><span className="eyebrow">New User</span><button type="button" onClick={close}><X size={18} /></button></div>
          <div className="grid sm:grid-cols-2 gap-4">
            <input required placeholder="Full name" value={creating.full_name} onChange={(e) => updateCreatingField("full_name", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-user-name-input" />
            <input required type="email" placeholder="Email" value={creating.email} onChange={(e) => updateCreatingField("email", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-user-email-input" />
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <select value={creating.role_key} onChange={(e) => updateCreatingField("role_key", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-user-role-select">
              {assignableRoles.map((r) => <option key={r.key} value={r.key}>{r.name}</option>)}
            </select>
            <input required type="password" minLength={8} placeholder="Temporary password (min 8 chars)" value={creating.password} onChange={(e) => updateCreatingField("password", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-user-password-input" />
          </div>
          <button type="submit" className="btn-solid-pearl" data-testid="admin-user-save-btn">Create User</button>
        </form>
      )}

      {loading ? <p className="text-small">Loading…</p> : (
        <div className="space-y-3">
          {users.map((u) => (
            <div key={u.id} className="neu-surface p-5 flex items-center justify-between gap-4 flex-wrap" data-testid={`admin-user-row-${u.email}`}>
              <div>
                <p className="text-body font-semibold" style={{ color: "var(--gg-ivory)" }}>{u.full_name} {u.is_owner && <span className="eyebrow ml-2" style={{ color: "var(--gg-logo-gold)" }}>Owner</span>}</p>
                <p className="text-small">{u.email} &middot; {u.role_key} {!u.active && "· Deactivated"}</p>
              </div>
              {!u.is_owner && u.active && (
                <button onClick={() => deactivate(u.id)} className="btn-outline-silver btn-pill-sm" data-testid={`admin-user-deactivate-${u.email}`}><UserX size={13} /> Deactivate</button>
              )}
            </div>
          ))}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminUsers;
